<div class="footer mt-70 hide-mobile">
  <div class="container flex-row">
    <div class="flex-row w-100">
      <div class="flex-column logo-block">
        <div class="logo" routerLink="/home" style="margin-top: -6px;">
          <img src="../../../assets/fsetan_logo.png" alt="" style="width: 258px;">

        </div>
<!--        <p  class="footer-phone1">8 (495) 135-43-15</p>-->
        <p class="footer-free-call mt-3">Copyright © 2003—2025 Протос Экспертиза</p>
      </div>
      <div class="flex-column address">
        <p>107078, Россия, Москва</p>
        <p>ул. Старая Басманная, д. 7, стр. 2</p>
        <p>Телефон: +7 (495) 135-43-15</p>
        <p>E-mail: <span class="underlined">fsetan@gmail.com</span></p>
      </div>
      <div class="flex-column link-bl" style=" font-weight: 500; line-height: 110%;">
        <p class="underlined" routerLink="/expprombez">Экспертиза промышленной безопасности</p>
        <p class="underlined" routerLink="/proekt-likvidatsii-i-konservatsii-opo/likvidatsiya/">Ликвидация ОПО</p>
        <p class="underlined" routerLink="/tehnicheskoe-perevooruzhenie-opo/">Техническое перевооружение ОПО</p>
        <p class="underlined" routerLink="/identifikaciya/">Идентификация ОПО</p>
      </div>
      <div class="flex-column link-bl" style=" font-weight: 500; line-height: 110%;">
        <p class="underlined" routerLink="/expertkltp/">ЭПБ документации КЛТП</p>
        <p class="underlined" routerLink="/proekt-likvidatsii-i-konservatsii-opo/konservatsiya/">Консервация ОПО</p>
        <p class="underlined" routerLink="/tekhnicheskoe-diagnostirovanie/">Техническое освидетельствование ОПО</p>
        <p class="underlined" routerLink="/identifikaciya/">Аудит ОПО</p>
      </div>

    </div>
  </div>
</div>
<div class="footer mt-70 display-mobile">
  <div class="container flex-column">       <div class="flex-row" style="gap: 10px;     justify-content: space-between;">
    <div class="flex-column" style="width: 50%">
      <div class="logo" routerLink="/home" style="margin-top: -8px;">
        <img src="../../../assets/fsetan_logo.png" alt="" style="width: 258px;">

      </div>
      <p style="font-family: Hortensia, sans-serif;" class="hort-footer-label">Более 20 лет в лицензировании</p>
      <div>

      </div>
    </div><div class="flex-column" style=" font-weight: 500; line-height: 130%; align-items: end">
    <p  class="footer-phone1">8 (495) 151-14-89</p>
    <p class="footer-phone2">8 (800) 775-83-14</p>
    <p class="footer-free-call">Звонки бесплатно по РФ</p>

  </div>

  </div>

    <!--    <form action="" method="post" class="newRecall" name="recall" >-->
    <!--      <div class="flex-column">-->
    <!--        <div class="field">-->
    <!--          <input type="hidden" name="id_base" value="0" class="not-req id_base_recall" id="id_id_base">-->
    <!--          <input type="hidden" name="service_title" value="Обратный звонок, услуга не указана"-->
    <!--                 id="id_service_title">-->

    <!--          <label for="id_utel">Ваш телефон:</label>-->
    <!--          <input type="tel" name="utel" style="width: 100%;" placeholder="+7 456 777-88-99" maxlength="20" id="id_utel">-->
    <!--        </div>-->

    <!--        <p class="badge-paragraph">-->
    <!--          Отправляя форму, я даю согласие на обработку моих&nbsp;персональных данных-->
    <!--        </p>-->

    <!--      </div>-->

    <!--      <div class="flex-row" style="gap: 10px;">-->
    <!--        <button class="button__submit call-me_btn w-100" style="height: 50px;"  data-class="new-recall"-->
    <!--                data-url="/user_form/forms/order_call_inter/">Перезвоните мне-->
    <!--        </button>-->
    <!--      </div>-->
    <!--    </form>-->

    <div class="social-links">
      <a href="https://vk.com/protos_group">
        <svg alt="vk" class="social__icon" width="40" height="40" viewBox="0 0 26 26" fill="none"
             xmlns="http://www.w3.org/2000/svg">
          <path clip-rule="evenodd"
                d="M.79 13c0-6.627 5.324-12 11.893-12 6.57 0 11.895 5.373 11.895 12s-5.325 12-11.895 12C6.114 25 .79 19.627.79 13z"
                stroke="currentColor" stroke-width="1.5"></path>
          <path fill-rule="evenodd" clip-rule="evenodd"
                d="M13.306 16.538s.229-.025.346-.15c.107-.114.104-.33.104-.33s-.015-1.007.457-1.156c.466-.146 1.064.974 1.698 1.405.479.326.842.254.842.254l1.695-.023s.886-.054.466-.744c-.035-.057-.245-.51-1.26-1.444-1.063-.976-.92-.818.36-2.508.78-1.028 1.09-1.656.993-1.925-.092-.257-.666-.189-.666-.189l-1.907.012s-.142-.019-.247.043a.533.533 0 00-.168.203s-.302.796-.705 1.473c-.85 1.428-1.189 1.504-1.328 1.415-.323-.207-.242-.83-.242-1.274 0-1.384.212-1.961-.413-2.11-.207-.05-.36-.083-.89-.089-.681-.006-1.257.003-1.583.16-.218.106-.385.34-.283.354.126.017.412.076.563.28.196.264.189.855.189.855s.112 1.63-.263 1.832c-.257.139-.609-.144-1.367-1.44-.388-.664-.68-1.398-.68-1.398s-.057-.137-.158-.21a.785.785 0 00-.293-.117l-1.813.011s-.272.008-.372.125c-.089.104-.007.32-.007.32s1.42 3.288 3.027 4.945c1.473 1.52 3.146 1.42 3.146 1.42h.759z"
                fill="currentColor"></path>
        </svg>
      </a>
      <a href="https://t.me/protos_group">
        <svg alt="tg" class="social__icon" width="40" height="40" viewBox="0 0 24 24" fill="none"
             xmlns="http://www.w3.org/2000/svg">
          <circle cx="12" cy="12" r="11.35" stroke="#494949" stroke-width="1.3"></circle>
          <path d="M16.445 7.007c-.258-.03-.582.04-.944.172-.661.24-9.112 3.845-9.6 4.053-.462.198-.9.414-.901.725 0 .22.13.343.487.471.371.134 1.308.418 1.86.571.534.148 1.14.02 1.48-.193.36-.224 4.516-3.019 4.814-3.263.298-.245.536.07.292.314-.243.245-3.097 3.026-3.473 3.411-.457.468-.132.953.174 1.147.35.222 2.867 1.918 3.246 2.19s.762.395 1.115.395c.352 0 .537-.466.712-1.007.206-.632 1.168-6.94 1.287-8.183.036-.376-.083-.627-.314-.739a.734.734 0 00-.235-.064z"
                fill="#494949"></path>
        </svg>
      </a>
      <a href="https://dzen.ru/id/5c6efeff37874700af70890d?share_to=link">
        <svg alt="zen" class="social__icon" width="40" height="40" viewBox="0 0 24 24" fill="none"
             xmlns="http://www.w3.org/2000/svg">
          <circle cx="12" cy="12" r="11.35" stroke="#494949" stroke-width="1.3"></circle>
          <path fill-rule="evenodd" clip-rule="evenodd"
                d="M11.64 0c-.062 4.87-.396 7.6-2.22 9.423-1.823 1.823-4.553 2.16-9.42 2.213v.717c4.867.063 7.597.39 9.42 2.213 1.825 1.824 2.158 4.564 2.22 9.423h.72c.062-4.87.396-7.599 2.22-9.423 1.823-1.823 4.553-2.16 9.42-2.213v-.717c-4.867-.063-7.597-.39-9.42-2.213C12.754 7.599 12.421 4.859 12.36 0h-.72z"
                fill="#494949"></path>
        </svg>
      </a>

    </div>

  </div>
</div>
